// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refEnvironmentService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refEnvironments/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refEnvironments/${id}`).then(handleResponse);
}

function add(refEnvironment) {
    return axios.post('/refEnvironments', refEnvironment).then(handleResponse);
}

function update(refEnvironment) {
    return axios.put(`/refEnvironments/${refEnvironment.refEnvironmentId}`, refEnvironment).then(handleResponse);
}

function deleteEntity(refEnvironment) {
    return axios.delete(`/refEnvironments/${refEnvironment.refEnvironmentId}`).then(handleResponse);
}
